// removed by extract-text-webpack-plugin
module.exports = {"table-toolbar-wrapper":"table-toolbar-wrapper","tableToolbarWrapper":"table-toolbar-wrapper","table-toolbar":"table-toolbar","tableToolbar":"table-toolbar","total-wrapper":"total-wrapper","totalWrapper":"total-wrapper","roles-buttons-wrapper":"roles-buttons-wrapper","rolesButtonsWrapper":"roles-buttons-wrapper","add-user-button":"add-user-button","addUserButton":"add-user-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/roles/toolbar/style.scss
// module id = 1623
// module chunks = 0